import { inject } from '@angular/core';
import { AuthService } from '../services';
import { ConfigurationService } from '@sc/data-access-configuration';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

export const InsurerXGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const configService = inject(ConfigurationService);

  return authService.userIsInsurerX$(configService.getId()).pipe(
    map((isInsurerX) => {
      return isInsurerX ? true : router.parseUrl('/login');
    })
  );
};
